import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatError } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';
import { TranslocoModule } from '@jsverse/transloco';
import { RegexPatterns } from '@anihis/shared/src/constants/regex-patterns';
import { RoleType } from '@anihis/core/data-access';
import { ActivateAccountStore } from './activate-account.store';
import { LoadingStatus } from '../../shared/enums/loading';

@Component({
  selector: 'anihis-activate-account',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoModule,
    MatError,
    MatButtonModule,
    MatToolbarModule,
  ],
  templateUrl: './activate-account.component.html',
  styleUrl: './activate-account.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ActivateAccountStore],
})
export class ActivateAccountComponent extends FormBaseComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  store = inject(ActivateAccountStore);

  readonly status = LoadingStatus;
  readonly RoleType = RoleType;
  showValidationErrors = signal(false);
  isManagerActivation = signal(false);

  constructor() {
    super();
    const role = this.route.snapshot.queryParamMap.get('role');
    if (role === RoleType.Manager) {
      this.isManagerActivation.set(true);
      this.store.setRole(RoleType.Manager);
    }
    this.initializeForm();
  }

  private initializeForm() {
    this.form = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(RegexPatterns.EMAIL_REGEX),
        ],
      ],
    });
  }

  back() {
    this.router.navigateByUrl('/login');
  }

  submit() {
    this.showValidationErrors.set(true);

    if (this.checkFormValidity()) return;

    const email = this.form.get('email')?.value;
    this.store.requestActivation(email).subscribe();
  }
}
